export default "__VITE_ASSET__CIzgwUtI__"